export const marketingCategories = [

  { name: "Growth & Acquisition", icon: FaRocket },
  { name: "Social & Community", icon: FaUsers },
  { name: "Content & Creative", icon: FaPenFancy },
  { name: "Strategy & Advisory", icon: FaChess },
  { name: "Brand & Identity", icon: FaPalette },
];
import { FaBullhorn, FaChartLine, FaCheckCircle, FaChess, FaCoins, FaFileAlt, FaFilePowerpoint, FaGlobe, FaHandHoldingUsd, FaHashtag, FaNewspaper, FaPaintBrush, FaPalette, FaParachuteBox, FaPenFancy, FaPeopleArrows, FaRocket, FaUsers } from "react-icons/fa";
export const marketingData = [

  {
    id: 1,
    title: "Crypto Token Marketing",
    subtitle:
      "Position your token for visibility, adoption, and long-term growth",
    description:
      "Crypto token marketing goes beyond simple promotion — it’s about creating the right narrative, targeting the right audience, and building trust within the ecosystem. At Xeer Technology, we design tailored strategies that ensure your token reaches investors, traders, and early adopters while maintaining long-term value perception.",
    category: "Growth & Acquisition",
    icon: FaCoins,
    image: "/assets/img/marketing/crypto_token_marketing.jpg",
    accentColor: "#3366ff",
    features: [
      "Token launch strategy & positioning",
      "Market awareness campaigns",
      "Community-driven growth",
      "Investor-focused outreach",
    ],
    tools: ["CoinGecko", "CoinMarketCap", "DexTools", "Uniswap", "PancakeSwap"],
    detailedDescription:
      "Crypto token marketing goes beyond simple promotion — it’s about creating the right narrative, targeting the right audience, and building trust within the ecosystem. At Xeer Technology, we design tailored strategies that ensure your token reaches investors, traders, and early adopters while maintaining long-term value perception.",
    benefits: [
      "Strong launch presence",
      "Higher token visibility",
      "Increased adoption and engagement",
    ],

    process: [
      "We begin with market and competitor research to understand positioning gaps. Then we design a go-to-market strategy, followed by multi-channel campaign execution across social, PR, and communities. Continuous monitoring and optimization ensure sustainable growth and better engagement.",
    ],
  },
  {
    id: 2,
    title: "PR & Media",
    subtitle: "Build credibility through trusted media exposure",
    description:
      "In the Web3 space, credibility is everything. Our PR and media services focus on placing your project in top-tier crypto and tech publications, ensuring your story reaches the right audience and builds trust among investors and users.",
    category: "Content & Creative",
    icon: FaNewspaper,
    image: "/assets/img/marketing/pr_and_media.jpg",
    accentColor: "#f43f5e",
    features: [
      "Press release writing & distribution",
      "Media placements in crypto platforms",
      "Brand storytelling",
      "Global PR outreach",
    ],
    tools: [
      "CoinDesk",
      "CoinTelegraph",
      "Decrypt",
      "The Block",
      "Bloomberg Crypto",
    ],
    detailedDescription:
      "In the Web3 space, credibility is everything. Our PR and media services focus on placing your project in top-tier crypto and tech publications, ensuring your story reaches the right audience and builds trust among investors and users.",
    benefits: [
      "Increased brand authority",
      "Global exposure",
      "Strong market credibility",
    ],
    process: [
      "We craft a compelling brand narrative, followed by press content creation aligned with your goals. Our team then handles media outreach and publication, ensuring visibility across relevant platforms, along with performance tracking and reporting.",
    ],
  },
  {
    id: 3,
    title: "Marketing Strategies",
    subtitle: "Data-driven strategies for sustainable Web3 growth",
    description:
      "Every successful Web3 project is backed by a clear and well-defined marketing strategy. We create structured growth plans based on your product, audience, and market dynamics to ensure long-term scalability.",
    category: "Strategy & Advisory",
    icon: FaChartLine,
    image: "/assets/img/marketing/marketing_strategies.jpg",
    accentColor: "#10b981",
    features: [
      "Go-to-market strategy",
      "Growth funnel design",
      "Audience targeting",
      "Campaign planning",
    ],
    tools: [
      "Google Analytics",
      "Mixpanel",
      "Dune Analytics",
      "Nansen",
      "SEMrush",
    ],
    detailedDescription:
      "Every successful Web3 project is backed by a clear and well-defined marketing strategy. We create structured growth plans based on your product, audience, and market dynamics to ensure long-term scalability.",
    benefits: [
      "Clear growth direction",
      "Better ROI on campaigns",
      "Focused audience targeting",
    ],
    process: [
      "We start with deep analysis of your product and audience, then build a custom strategy roadmap. This is followed by execution planning and channel selection, and finally continuous performance optimization based on data insights.",
    ],
  },
  {
    id: 4,
    title: "Social Media Marketing",
    subtitle: "Build a strong and engaging Web3 presence",
    description:
      "Social media plays a critical role in shaping perception and engagement in Web3. We help build consistent and impactful brand presence across platforms like X (Twitter), LinkedIn, and Telegram.",
    category: "Social & Community",
    icon: FaHashtag,
    image: "/assets/img/marketing/social_media_marketing.jpg",
    accentColor: "#0ea5e9",
    features: [
      "Content creation & scheduling",
      "Daily posting & engagement",
      "Community interaction",
      "Brand voice development",
    ],
    tools: ["Twitter/X", "Discord", "Telegram", "Hootsuite", "Sprout Social"],
    detailedDescription:
      "Social media plays a critical role in shaping perception and engagement in Web3. We help build consistent and impactful brand presence across platforms like X (Twitter), LinkedIn, and Telegram.",
    benefits: [
      "Strong online presence",
      "Increased engagement",
      "Organic audience growth",
    ],
    process: [
      "We develop a content strategy and calendar, execute daily posting and engagement activities, and continuously track performance metrics to refine the strategy and maximize reach.",
    ],
  },
  {
    id: 5,
    title: "Influence Marketing",
    subtitle: "Amplify reach through trusted voices in Web3",
    description:
      "Influencer marketing helps projects gain immediate visibility and trust.",
    category: "Growth & Acquisition",
    icon: FaBullhorn,
    image: "/assets/img/marketing/influencer_marketing.jpg",
    accentColor: "#d946ef",
    features: [
      "Influencer identification & outreach",
      "Campaign execution",
      "Sponsored promotions",
      "Performance analytics",
    ],
    tools: ["YouTube", "TikTok", "Twitter/X", "Instagram", "Twitch"],
    detailedDescription:
      "Influencer marketing helps projects gain immediate visibility and trust. We collaborate with relevant Web3 influencers who align with your niche and audience.",
    benefits: ["Faster reach", "Increased credibility", "Higher engagement"],
    process: [
      "We identify relevant influencers, manage outreach and negotiations, execute campaigns, and track engagement and ROI metrics for continuous improvement.",
    ],
  },
  {
    id: 6,
    title: "Web3 Campaigns",
    subtitle: "Targeted campaigns built for blockchain ecosystems",
    description:
      "Web3 campaigns require a different approach compared to traditional marketing. We design and execute campaigns specifically tailored for blockchain audiences and platforms.",
    category: "Growth & Acquisition",
    icon: FaGlobe,
    image: "/assets/img/marketing/web3.jpg",
    accentColor: "#f59e0b",
    features: [
      "Token/NFT launch campaigns",
      "DAO/community campaigns",
      "Growth hacking strategies",
      "Multi-platform campaigns",
    ],
    tools: ["Galxe", "Layer3", "QuestN", "Zealy", "Guild.xyz"],
    detailedDescription:
      "Web3 campaigns require a different approach compared to traditional marketing. We design and execute campaigns specifically tailored for blockchain audiences and platforms.",
    benefits: [
      "Targeted traction",
      "Increased adoption",
      "Strong community engagement",
    ],
    process: [
      "We define campaign objectives, create engagement strategies, execute across multiple channels, and continuously optimize for better results.",
    ],
  },
  {
    id: 7,
    title: "Content Marketing",
    subtitle: "Build authority through valuable content",
    description:
      "Content is the backbone of any Web3 project. We create meaningful, informative, and engaging content that builds trust and positions your brand as an authority.",
    category: "Content & Creative",
    icon: FaFileAlt,
    image: "/assets/img/marketing/content_marketing.jpg",
    accentColor: "#06b6d4",
    features: [
      "Blogs & articles",
      "Whitepapers & documentation",
      "Social media content",
      "Educational content",
    ],
    tools: ["WordPress", "Substack", "Medium", "Ahrefs", "Canva"],
    detailedDescription:
      "Content is the backbone of any Web3 project. We create meaningful, informative, and engaging content that builds trust and positions your brand as an authority.",
    benefits: [
      "Improved brand authority",
      "Better SEO visibility",
      "Strong audience trust",
    ],
    process: [
      "We conduct topic research, create high-quality content, distribute it across platforms, and track engagement and SEO performance.",
    ],
  },
  {
    id: 8,
    title: "Community Building",
    subtitle: "Create and scale loyal Web3 communities",
    description:
      "A strong community is the foundation of any successful Web3 project. We help build and manage active communities that drive engagement and loyalty.",
    category: "Social & Community",
    icon: FaPeopleArrows,
    image: "/assets/img/marketing/community_building.jpg",
    accentColor: "#7c3aed",
    features: [
      "Telegram & Discord setup",
      "Community moderation",
      "Engagement campaigns",
      "Growth strategies",
    ],
    tools: ["Discord", "Telegram", "Combot", "Collab.Land", "Commonwealth"],
    detailedDescription:
      "A strong community is the foundation of any successful Web3 project. We help build and manage active communities that drive engagement and loyalty.",
    benefits: ["Loyal user base", "Higher retention", "Organic growth"],
    process: [
      "We set up community platforms, implement engagement strategies, manage daily interactions, and scale the community through targeted campaigns.",
    ],
  },
  {
    id: 9,
    title: "Airdrop Marketing",
    subtitle: "Accelerate user acquisition with strategic airdrops",
    description:
      "Airdrops are one of the most effective ways to attract users quickly. We design campaigns that not only drive participation but also ensure long-term engagement.",
    category: "Growth & Acquisition",
    icon: FaParachuteBox,
    image: "/assets/img/marketing/airdrop_marketing.jpg",
    accentColor: "#8b5cf6",
    features: [
      "Campaign design",
      "Task-based participation",
      "User onboarding",
      "Token distribution",
    ],
    tools: ["Galxe", "QuestN", "DeBank", "Chainlink VRF", "Merkle.io"],
    detailedDescription:
      "Airdrops are one of the most effective ways to attract users quickly. We design campaigns that not only drive participation but also ensure long-term engagement.",
    benefits: [
      "Rapid user growth",
      "Increased awareness",
      "Community expansion",
    ],
    process: [
      "We define campaign goals, create task-based engagement models, execute the campaign, and manage distribution and retention strategies.",
    ],
  },
  {
    id: 10,
    title: "Rebranding",
    subtitle: "Transform your identity for better positioning",
    description:
      "Rebranding helps projects stay relevant and competitive. We redesign your brand identity to align with your vision and market expectations.",
    category: "Brand & Identity",
    icon: FaPaintBrush,
    image: "/assets/img/marketing/rebranding.jpg",
    accentColor: "#ff4d4d",
    features: [
      "Brand identity redesign",
      "Messaging refinement",
      "Visual upgrades",
      "Positioning strategy",
    ],
    tools: ["Figma", "Adobe Creative Suite", "Framer", "Webflow", "Lottie"],
    detailedDescription:
      "Rebranding helps projects stay relevant and competitive. We redesign your brand identity to align with your vision and market expectations.",
    benefits: [
      "Improved brand perception",
      "Better market positioning",
      "Stronger identity",
    ],
    process: [
      "We analyze current brand gaps, define a new positioning strategy, implement design and messaging changes, and ensure smooth rollout.",
    ],
  },
  {
    id: 11,
    title: "Pitch Deck Design",
    subtitle: "Create impactful investor-ready presentations",
    description:
      "A strong pitch deck is essential for fundraising. We design visually compelling and content-rich decks that clearly communicate your vision.",
    category: "Strategy & Advisory",
    icon: FaFilePowerpoint,
    image: "/assets/img/marketing/pitch_deck_design.jpg",
    accentColor: "#f97316",
    features: [
      "Investor pitch decks",
      "Fundraising presentations",
      "Visual storytelling",
      "Data-driven slides",
    ],
    tools: [
      "Figma",
      "PowerPoint",
      "Google Slides",
      "Pitch.com",
      "Beautiful.ai",
    ],
    detailedDescription:
      "A strong pitch deck is essential for fundraising. We design visually compelling and content-rich decks that clearly communicate your vision.",
    benefits: [
      "Better investor engagement",
      "Clear communication",
      "Higher funding potential",
    ],
    process: [
      "We structure key messaging, design high-quality visuals, refine content, and deliver a polished investor-ready deck.",
    ],
  },
  {
    id: 12,
    title: "Fund Raising",
    subtitle: "Support your journey to secure capital",
    description:
      "We assist Web3 projects in preparing and executing structured fundraising strategies to connect with the right investors.",
    category: "Strategy & Advisory",
    icon: FaHandHoldingUsd,
    image: "/assets/img/marketing/fund_raising.jpg",
    accentColor: "#22c55e",
    features: [
      "Fundraising strategy",
      "Investor outreach",
      "Tokenomics guidance",
      "Pitch support",
    ],
    tools: [
      "AngelList",
      "CryptoRank",
      "Messari",
      "TokenTerminal",
      "Crunchbase",
    ],
    detailedDescription:
      "We assist Web3 projects in preparing and executing structured fundraising strategies to connect with the right investors.",
    benefits: [
      "Access to investors",
      "Structured funding approach",
      "Improved success rate",
    ],
    process: [
      "We prepare your fundraising materials, identify target investors, manage outreach, and support through the closing phase.",
    ],
  },
  {
    id: 13,
    title: "Exchange Listing",
    subtitle: "Get your token listed on major exchanges",
    description:
      "Listing your token on exchanges is crucial for liquidity and accessibility. We guide you through the entire process..",
    category: "Strategy & Advisory",
    icon: FaGlobe,
    image: "/assets/img/marketing/exchange_listing.jpg",
    accentColor: "#22c55e",
    features: [
      "Exchange coordination",
      "Listing strategy",
      "Documentation support",
      "Technical integration",
    ],
    tools: [
      "AngelList",
      "CryptoRank",
      "Messari",
      "TokenTerminal",
      "Crunchbase",
    ],
    detailedDescription:
      "Listing your token on exchanges is crucial for liquidity and accessibility. We guide you through the entire process.",
    benefits: ["Increased liquidity", "Market access", "Trading volume growth"],
    process: [
      "We prepare all required documentation, connect with exchange partners, manage listing process, and support launch execution.",
    ],
  },
  {
    id: 14,
    title: "Listing on CoinGecko",
    subtitle: "Enhance visibility on global tracking platforms",
    description:
      "Being listed on platforms like CoinGecko increases credibility and investor trust by making your token publicly visible.",
    category: "Strategy & Advisory",
    icon: FaCheckCircle,
    image: "/assets/img/marketing/token_listing.jpg",
    accentColor: "#22c55e",
    features: [
      "Listing application support",
      "Data verification",
      "Token integration",
      "Compliance guidance",
    ],
    tools: [
      "AngelList",
      "CryptoRank",
      "Messari",
      "TokenTerminal",
      "Crunchbase",
    ],
    detailedDescription:
      "Being listed on platforms like CoinGecko increases credibility and investor trust by making your token publicly visible.",
    benefits: [
      "Public visibility",
      "Increased trust",
      "Better market credibility",
    ],
    process: [
      "We prepare listing requirements, submit the application, follow up with platforms, and ensure successful approval.",
    ],
  },
  {
    id: 15,
    title: "Token Listing on CoinMarketCap (CMC)",
    subtitle:
      "Get your token recognized on one of the world’s leading crypto data platforms",
    description:
      "At Xeer Technology, we assist in streamlining the entire CMC listing process, ensuring your project meets all technical and compliance requirements for successful approval.",
    category: "Strategy & Advisory",
    icon: FaChartLine,
    image: "/assets/img/marketing/coingecko.jpg",
    accentColor: "#22c55e",
    features: [
      "Complete CMC listing application support",
      "Token data preparation (supply, contracts, explorers, etc.)",
      "Exchange and liquidity validation guidance",
      "API and data integration assistance",
      "Ongoing follow-ups until approval",
    ],
    tools: [
      "AngelList",
      "CryptoRank",
      "Messari",
      "TokenTerminal",
      "Crunchbase",
    ],
    detailedDescription:
      "CoinMarketCap (CMC) is one of the most trusted and widely used platforms in the crypto industry for tracking token data, prices, and market performance. Listing your token on CMC significantly enhances credibility, visibility, and investor confidence, making it easier for traders and investors to discover and track your project.",
    benefits: [
      "Increased global visibility",
      "Higher investor trust and credibility",
      "Easy tracking for traders and platforms",
      "Improved market presence and discoverability",
    ],
    process: [
      "We begin by analyzing your token readiness, including liquidity, exchange listings, and technical requirements. Then we prepare all necessary documentation and data points required by CoinMarketCap.",
      "Our team handles the submission process, ensures correct data formatting, and manages continuous follow-ups with the CMC team. We also assist with post-listing updates and corrections if needed.",
    ],
  },
];
